import { createFileRoute } from '@tanstack/react-router';
import { FinanceCategoriesScreen } from '../../screens/finance/Categories';

export const Route = createFileRoute('/finance/categories')({
  component: FinanceCategoriesScreen,
});
